<template>
  <div>
    <panel
      title="Klubski popusti"
      collapsable
    >
      <template v-slot:actions>
        <el-button
          v-if="user.isAdmin"
          type="primary"
          icon="el-icon-plus"
          size="medium"
          circle
          @click="openManageDeduction = true" />

      </template>

      <club-deductions-table
        :data="clubDeductions"
        @edit="openEdit($event)"
        @delete="onDelete($event)" />
    </panel>

    <manage-club-cost-deduction
      v-if="openManageDeduction"
      :tournament="tournament"
      :club-deduction="editing"
      @edit="onEdit($event)"
      @add="onAdd($event)"
      @close="close()" />
  </div>
</template>

<script>
import errorHandler from '@/common/errorHandler.js'

import ClubDeductionsTable from './ClubDeductionsTable'
import ManageClubCostDeduction from './ManageClubCostDeduction'

export default {
  components: {
    ClubDeductionsTable,
    ManageClubCostDeduction
  },

  props: {
    tournament: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      editing: null,
      openManageDeduction: false
    }
  },

  computed: {
    clubDeductions () {
      return this.tournament.clubDeductions || []
    },

    user () {
      return this.$store.state.auth.user
    }
  },

  methods: {
    openEdit (deduction) {
      this.editing = deduction
      this.openManageDeduction = true
    },

    async onDelete (deduction) {
      const loading = this.$loading()
      try {
        await this.$store.dispatch('clubDeductions/delete', deduction.id)
        this.$message.success(this.$tc('messages.success_deleted_club_deduction'))
        this.$emit('delete', deduction)
        this.$store.commit('tournaments/removeClubDeduction', { tournament: this.tournament, id: deduction.id })
      } catch (e) {
        console.error(e)
        errorHandler(e)
      } finally {
        loading.close()
      }
    },

    onEdit (deduction) {
      this.$store.commit('tournaments/updateClubDeduction', { tournament: this.tournament, deduction: deduction })
      this.close()
    },

    onAdd (deduction) {
      this.$store.commit('tournaments/addClubDeduction', { tournament: this.tournament, deduction: deduction })
      this.close()
    },

    close () {
      this.editing = null
      this.openManageDeduction = false
    }
  }
}
</script>

<style lang="scss" scoped>
label {
  font-weight: bold;
  color: #000;
}

.discipline {
  padding-bottom: 5px;
  span {
    margin-right: 5px;
  }
}
</style>
